import { AppDispatch } from 'types/state';
import { GetChatRoomsParams } from 'types/services';
import { ChatRoom, ChatMessage } from 'types/chats';

export const chatRoomsThunk = (
  promise: Promise<[ChatRoom, ChatMessage][]>,
  meta: GetChatRoomsParams
) => (dispatch: AppDispatch): Promise<void> => {
  dispatch({
    name: 'CHAT_ROOMS_SERVICE',
    status: 'PENDING',
    meta
  });

  return promise.then(rooms => {
    dispatch({
      name: 'CHAT_ROOMS_SERVICE',
      status: 'RESOLVED',
      payload: rooms,
      meta
    });
  });
};
